import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { WHATSAPP_NUMBER } from '../lib/api';
import { Video, Home, Settings2, Sparkles, MessageCircle } from 'lucide-react';

export default function Booking() {
  const { lang, t } = useLanguage();

  const services = [
    { id: 'videocall', icon: Video, title: 'service_videocall', desc: 'service_videocall_desc' },
    { id: 'homevisit', icon: Home, title: 'service_homevisit', desc: 'service_homevisit_desc' },
    { id: 'pump', icon: Settings2, title: 'service_pump', desc: 'service_pump_desc' },
    { id: 'coaching', icon: Sparkles, title: 'service_coaching', desc: 'service_coaching_desc' },
  ];

  const buildLink = (serviceTitle) => {
    const msg =
      lang === 'zh'
        ? `Hi Soo, 我想预约「${serviceTitle}」服务，请告诉我下一步怎么做。`
        : `Hi Soo, I would like to book "${serviceTitle}" service. Please advise next steps.`;
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
  };

  return (
    <div className="container-app py-8 sm:py-12 animate-fade-in-up" data-testid="booking-page">
      <h1 className="font-heading text-3xl sm:text-4xl font-semibold text-ink mb-3">{t('booking_title')}</h1>
      <p className="text-ink-secondary mb-10">{t('booking_subtitle')}</p>

      <div className="grid sm:grid-cols-2 gap-5">
        {services.map((s) => {
          const Icon = s.icon;
          const title = t(s.title);
          return (
            <div key={s.id} className="card-base p-6 sm:p-8" data-testid={`service-${s.id}`}>
              <div className="w-12 h-12 rounded-2xl bg-sage-light flex items-center justify-center mb-4">
                <Icon size={20} className="text-sage" />
              </div>
              <h3 className="font-heading text-xl font-semibold text-ink mb-2">{title}</h3>
              <p className="text-sm text-ink-secondary leading-relaxed mb-5">{t(s.desc)}</p>
              <a
                href={buildLink(title)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`book-${s.id}-btn`}
                className="btn-primary w-full"
              >
                <MessageCircle size={16} className="mr-2" />
                {t('booking_book_btn')}
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
}
